<template>
  <div>
    <v-row align="center" class="mt-2 flex-column" v-if="loadingFunil">
      <v-col cols="12" :sm="7 - i" :md="7 - i" :lg="7 - i" v-for="i in 6" :key="i">
        <v-skeleton-loader type="text" class="mb-3 loading_height_funil"></v-skeleton-loader>
      </v-col>
    </v-row>
    <ul class="mt-8 px-1 largura_funil" v-if="!loadingFunil && !!funilOportunidades && !!funilOportunidades.etapas && funilOportunidades.etapas.length">
      <li class="item_funil" v-for="(item,index) in funilOportunidades.etapas" :key="index" :style="`width: ${calculaWidth(funilOportunidades.etapas.length, index)}`">
        <span class="fundo_diagonal d-none d-lg-block" :style="'background-color: ' + item.fet_cor"></span>
        <div class="status_area text-h2 text--thin" :style="'border-color: ' + item.fet_cor">
          {{item.fet_nome}}
        </div>
        <div :style="'background-color: ' + item.fet_cor" class="funil_cor" :class="$vuetify.theme.dark ? 'border-black' : 'border-white'">
          <div class="text-h2 text--thin">
            <b>{{item.oportunidades_total}}</b> <br>
            {{$root.Formatter.floatToMoney(item.oportunidades_valor_total)}}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Api from '@API'

export default {
  props: ['status'],
  data () {
    return {
      funis: [],
      funil: null,
      loading: false,
      loadingFunil: false,
      funilOportunidades: [],
      tipos: ['Sistema fotovoltaico']
    }
  },
  methods: {
    calculaWidth (total, index) {
      let width = 100
      let valorDiminuir = 80 / total
      width = width - (valorDiminuir * index)
      return `${width}%`
    },
    randomNumber (ate) {
      return Math.floor(Math.random() * ate) + 1
    },
    async getFunis () {
      this.loading = true
      await Api.get('funis')
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.funis = res.data
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os funis!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getFunilOportunidades () {
      if (this.funis.length === 0) return

      this.loadingFunil = true

      this.funil = this.funis[0].uuid_fun_id
      if (this.status === 3) {
        this.funil = this.funis[1].uuid_fun_id
      }

      const endpoint = `oportunidades/funil/${this.funil}?status=${this.status}`
      await Api.get(endpoint)
        .then(res => {
          if (res.data) {
            this.funilOportunidades = res.data
          }
          this.loadingFunil = false
        })
        .catch(err => {
          this.loadingFunil = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async loadFunctions () {
      await this.getFunis()
      await this.getFunilOportunidades()
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>>.v-skeleton-loader__text {
  height: 2em!important;
}
.largura_funil {
  margin: 0 auto;
  width: 50vw;
  @media (max-width: 991px){
    width: 100%;
  }
}
.item_funil {
  margin: 0 auto;
  margin-bottom: 30px;
  position: relative;
  text-align: center;
  .fundo_diagonal {
    opacity: 0.7;
    position: absolute;
    width: 55%;
    left: 90px;
    top: 82px;
    height: 50%;
    transform: rotate(17deg);
  }
  .funil_cor {
    align-items: center;
    display: flex;
    justify-content: center;
    height: 90px;
  }
  .status_area {
    align-items: center;
    border: 1px solid;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: 100%;
    left: -340px;
    padding: 5px;
    position: absolute;
    width: 300px;
  }
  &:nth-of-type(even) {
    .fundo_diagonal {
      left: inherit;
      right: 75px;
      transform: rotate(-21deg);
    }
    .status_area {
      left: inherit;
      right: -320px;
    }
  }
  &:nth-last-of-type(1) {
    .fundo_diagonal {
      visibility: hidden;
    }
  }
}
.funil_cor {
  overflow: hidden;
  position: relative;
  &:after {
    border-bottom: 93px solid;
    border-left: 60px solid transparent;
    bottom: 0;
    content: '';
    position: absolute;
    right: -1px;
  }
  &:before {
    border-bottom: 93px solid;
    border-right: 60px solid transparent;
    bottom: 0;
    content: '';
    left: -1px;
    position: absolute;
  }
}
.border-black {
  &:before {
    border-bottom-color: $black;
  }
  &:after {
    border-bottom-color: $black;
  }
}
.border-white {
  &:before {
    border-bottom-color: white;
  }
  &:after {
    border-bottom-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/oportunidades/FunilOportunidades.vue